import { ChangeDetectorRef, Component, Input, OnInit } from "@angular/core";
import { Subscription } from "rxjs";
import { LoadingService } from "../../viewer-components/services/internal-services/loading.service";

@Component({
  selector: "app-loading",
  templateUrl: "./loading.component.html",
  styleUrls: ["./loading.component.scss"],
  standalone: false,
})
export class LoadingComponent implements OnInit {
  @Input() loadingId: string;

  /** Direct visibility control. When provided, overrides the LoadingService-based control. */
  @Input() show: boolean | undefined = undefined;

  /** Optional label shown below the spinner. */
  @Input() label: string = '';

  showLoading = false;

  subscriptions: Subscription[] = [];

  constructor(
    private loadingService: LoadingService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit(): void {
    this.subscriptions.push(
      this.loadingService.showLoading$.subscribe((loadId: string) => {
        if (this.loadingId === loadId) {
          this.showLoading = true;
          this.cdr.detectChanges();
        }
      }),
    );

    this.subscriptions.push(
      this.loadingService.hideLoading$.subscribe((loadId: string) => {
        if (this.loadingId === loadId) {
          this.showLoading = false;
          this.cdr.detectChanges();
        }
      }),
    );
  }
}
